import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-642dbc50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-details-history" }
const _hoisted_2 = { class: "columns is-multiline" }
const _hoisted_3 = { class: "column is-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_measure_datatable = _resolveComponent("measure-datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_measure_datatable, {
          station: _ctx.station,
          measures: _ctx.measures,
          since: _ctx.since,
          before: _ctx.before
        }, null, 8 /* PROPS */, ["station", "measures", "since", "before"])
      ])
    ])
  ]))
}